import { dispatchCustomEvent } from '../../../utils/dispatch';
import { lang } from '../../../utils/langs';
import "./style.css"

function ButtonHub(props) {

    function handleClick() {
        dispatchCustomEvent('modal' + props.modalID, [])
        if (props.onClick ? props.onClick : false) { props.onClick() }
    }

    return (
        <button
            id={props.id ? "modal-btn-hub-" + props.id : "modal-btn-hub"}
            className='btn-hub'
            onClick={handleClick}
            type="button"
            disabled={props.disabled ? props.disabled : false}
        >
            <div className='icon-wrapper'>{props.icon}</div>
            <span className='label'>{lang('es', props.title)}</span>
        </button>
    )
}

export default ButtonHub
